import { ESearchQueryActionType, TSetSearchQuery } from './types';

export function setSearchQuery(searchQuery: string): TSetSearchQuery {
  return {
    type: ESearchQueryActionType.SetSearchQuery,
    payload: searchQuery,
  };
}
